/** Reads the Sitecore-authored "Redirect Page" link out of the rendered form markup.
 *  Returns null when nothing is configured or the link points off-site. */
export function resolveRedirectUrl(form: HTMLElement): string | null {
    const configured = form.querySelector<HTMLElement>("[data-redirect-url]")
        ?.dataset.redirectUrl;
    if (!configured) {
        return null;
    }

    try {
        const url = new URL(configured, document.location.origin);
        return url.origin === document.location.origin ? url.toString() : null;
    } catch {
        return null;
    }
}
